// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import { Observer } from "mobx-vue";
import ModuleWrapper from "../../../components/module_wrapper/ModuleWrapper";
import { ImageAspectRatio } from "../../../components/image_aspect_ratio/ImageAspectRatio";
import InlineSVG from "../../../components/inline_svg/InlineSVG";
import { Api } from "../../../api";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ImageAspectRatio,
    InlineSVG,
  },
})
export class ProductNextStepNavigationModule extends ModuleBase {
  public isDownloadModalVisible = false;

  public isPrintModalVisible = false;
  public printCoverSheet = true;
  public printLegalNoticeSheet = true;

  getBackgroundColorFromInstance(instance: object): string {
    return "white";
  }

  get currentProduct() {
    return this.$store.conversionWorldProduct.current;
  }

  get handlersucheLink() {
    let link = "/" + this.lang + "/haendlersuche";

    if (this.currentProduct && !this.currentProduct.is_van_solution) {
      link += "?abhId=" + this.currentProduct.bodybuilder.id;
    }

    return link;
  }

  get documents() {
    let result: object[] = [];

    this.instance["pdfs"].forEach((pdf) => {
      result.push({
        title: pdf["title"],
        link: this.getTranslatedImage(pdf["document"], this.lang, "full"),
        thumbnail: this.getTranslatedImage(
          pdf["thumbnail"],
          this.lang,
          "medium"
        ),
        type: this.getTranslatedImageType(pdf["document"], this.lang),
        size: this.getTranslatedImageSize(pdf["document"], this.lang),
      });
    });

    return result;
  }

  public onOpenDownloadModal() {
    this.isDownloadModalVisible = true;
  }

  public onCloseDownloadModal() {
    this.isDownloadModalVisible = false;
  }

  public getElementLink(linkData) {
    if (linkData["type"] === "haendlersuche") {
      return this.handlersucheLink;
    } else if (linkData["type"] === "downloads") {
      return "#";
    } else if (linkData["type"] === "print") {
      /*if (this.currentProduct) {
                return Api.conversionWorldService.getProductPdfLink(this.currentProduct.id)
            }*/
      return "#";
    } else {
      return linkData["link"]["href"];
    }
  }

  onElementClickHandler(event, linkData) {
    if (linkData["type"] === "downloads") {
      this.onOpenDownloadModal();
    } else if (linkData["type"] === "print") {
      this.onOpenPrintModal();
    }
  }

  public getDownloadPrintLink() {
    if (this.currentProduct) {
      return Api.conversionWorldService.getProductPdfLink(
        this.currentProduct.id,
        this.printCoverSheet,
        this.printLegalNoticeSheet
      );
    }

    return "#";
  }

  public onOpenPrintModal() {
    this.isPrintModalVisible = true;
  }

  public onClosePrintModal() {
    this.isPrintModalVisible = false;
  }

  public mounted() {
    this.animate();
  }

  private animate() {
    // Start the animation
    // Note: We do not use Vue States for this because the rerendering needs to much time
    // and therefore destorys the animation.
    this.$nextTick(() => {
      let elements = <HTMLElement[]>this.$refs["element"];

      const duration = 150;
      const className = `${this.$appPrefix}-next-step-navigation__element--activate`;

      if (elements) {
        // Make activation animation
        elements.forEach((element, index) => {
          setTimeout(() => {
            element.classList.add(className);
          }, (index + 1) * duration);
        });

        // End activation animation
        setTimeout(() => {
          elements.forEach((element) => {
            element.classList.remove(className);
          });
        }, Math.max(2000, (elements.length + 2) * duration));
      }
    });
  }
}
